// extracted by mini-css-extract-plugin
module.exports = {"container":"PhotoCropper_container__2Wi9m","wrapper":"PhotoCropper_wrapper__mYRGc","control":"PhotoCropper_control__PBSfu","button":"PhotoCropper_button__pJs-L"};